exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-45014898] {\n  background-color: white;\n  border-radius: 0;\n  box-shadow: 0 20px 60px 0 rgba(41, 67, 100, 0.21);\n  width: 100%;\n  height: 400px;\n  padding: 0;\n}\n.card-icon[data-v-45014898] {\n  height: auto;\n  max-height: 400px;\n  border-radius: 5px;\n}", ""]);

// exports
